export const hasScope = (scope?: string) => {
	if (!scope) {
		return false;
	}

	return true;
};
